/**
 * @enum ClipboardFormat
 * @description Defines the format used when copying a value to the clipboard.
 * Pass to `clipboardFormat` input on {@link ClipboardDirective}.
 */
export enum ClipboardFormat {

  /**
   * @description Automatically detect the format from the value type (default).
   * - `Blob | File | HTMLImageElement` → Image
   * - `string` starting with `<` → Html
   * - Everything else → Text
   */
  Auto  = 'auto',

  /**
   * @description Copy as plain text using `navigator.clipboard.writeText()`.
   */
  Text  = 'text',

  /**
   * @description Copy as HTML using `navigator.clipboard.write()` with MIME type `text/html`.
   */
  Html  = 'html',

  /**
   * @description Copy as an image using `navigator.clipboard.write()` with the blob MIME type.
   */
  Image = 'image',

}

/**
 * @type IClipboardFormat
 * @description Union type accepting both the enum and its string literal equivalents.
 */
export type IClipboardFormat = ClipboardFormat | 'auto' | 'text' | 'html' | 'image';
